import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow_down",
  "use": "icon-arrow_down-usage",
  "viewBox": "0 0 16 9",
  "content": "<symbol viewBox=\"0 0 16 9\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow_down\">\n<path d=\"M14.2495 0.659979L7.99953 6.75373L1.74953 0.659979C1.63245 0.542896 1.49578 0.484354 1.33953 0.484354C1.18328 0.484354 1.04661 0.542896 0.929531 0.659979C0.812448 0.777062 0.753906 0.913729 0.753906 1.06998C0.753906 1.22623 0.80599 1.35644 0.910156 1.4606L7.57015 7.94498C7.68724 8.06206 7.83057 8.1206 8.00015 8.1206C8.16974 8.1206 8.31307 8.06206 8.43015 7.94498L15.0902 1.47998C15.1943 1.3629 15.2464 1.2229 15.2464 1.05998C15.2464 0.897062 15.1879 0.760396 15.0708 0.649979C14.9537 0.539563 14.817 0.484145 14.6608 0.483729C14.5045 0.483312 14.3679 0.541854 14.2508 0.659354L14.2495 0.659979Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/arrow_down.svg
// module id = yyuO
// module chunks = 258